/**
 * The QuoteHero mark, which brands the application and nothing else.
 *
 * The quotation document carries the Codemax mark instead: the document is issued
 * by Codemax, not by the tool that produced it. That rule holds even in the PDF's
 * own metadata, which a customer can open.
 */
export function Brand({ className = 'h-6' }: { className?: string }) {
  return (
    <picture className="block">
      {/* Two files rather than a filter: the wordmark is a gradient, and inverting
          it in CSS turns teal into something that is not the brand. */}
      <source srcSet="/quotehero-light.png" media="(prefers-color-scheme: dark)" />
      <img src="/quotehero-dark.png" alt="QuoteHero" className={`block ${className}`} />
    </picture>
  )
}

/**
 * The Codemax mark, for the screens somebody outside Codemax sees.
 *
 * The customer acceptance page is something a customer receives, so it is branded by the
 * company issuing the quotation rather than by the tool that produced it - the same rule
 * that keeps the QuoteHero mark off the PDF and out of its metadata. Nothing a Codemax
 * employee signs into should use this.
 *
 * The reseller portal follows the same rule and is a separate application, so it carries
 * its own copy of this rather than importing one from here.
 */
export function CodemaxBrand({ className = 'h-6' }: { className?: string }) {
  return (
    <picture className="block">
      <source srcSet="/codemax-light.png" media="(prefers-color-scheme: dark)" />
      <img src="/codemax-dark.png" alt="Codemax" className={`block ${className}`} />
    </picture>
  )
}
